/*
    handle user's decision on storing cookies,
    load Google Analytics if user accepts
*/
function LoadAnalytics () {
    // load external Google Analytics script
    const googleAnalyticsExternalScript = document.createElement("script");
    googleAnalyticsExternalScript.src = "https://www.googletagmanager.com/gtag/js?id=UA-290594409-1";
    document.getElementsByTagName("head")[0].appendChild(googleAnalyticsExternalScript);
    // load Google Analytics
    /* eslint-disable indent, no-undef, no-unused-vars */
        window.dataLayer = window.dataLayer || [];
        function gtag () {
            dataLayer.push(arguments);
        }
        gtag("js", new Date());
        gtag("config", "UA-290594409-1");
    /* eslint-enable indent, no-undef, no-unused-vars */
}
export default function () {
    // store cookie notice element
    const cookieNoticeElement       = document.getElementById("cookie_notice");
    // store class which displays cookie notice element
    const cookieNoticeVisibleClass  = "cookie_notice--is_visible";
    // store cookie notice analytics checkbox element
    const analyticsCheckbox         = document.getElementById("cookie_analytics_toggle");
    // store cookie notice accept all button element
    const acceptAllButton           = document.getElementById("cookie_accept_all");
    // store cookie dismiss button element
    const saveDismissButton = document.getElementById("cookie_save_and_dismiss");
    // store cookie key name
    const cookieName = "cla_ga_tracking";
    // store existing cookie
    let existingCookie = document.cookie.match(RegExp("(?:^|;\\s*)" + cookieName + "=([^;]*)"));
    // check for existing cookie
    if (existingCookie !== null) {
        existingCookie = existingCookie[1];
        if (existingCookie === "accepted") {
            // if user has previously accepted cookie notice, load Google Analytics
            LoadAnalytics();
        }
    } else {
        // store current root domain
        const domain = window.location.host;
        // get and store date one year from now
        Date.prototype.addYears = function (years) {
            const now = new Date();
            return new Date(now.setFullYear(now.getFullYear() + years));
        };
        const expirationDate = new Date().addYears(1);
        // store cookie arguments
        const cookieArguments = `expires=${expirationDate}; path=/; SameSite=Lax; secure`;
        // as there isn't an existing cookie, display cookie notice
        cookieNoticeElement.classList.add(cookieNoticeVisibleClass);
        // when user interacts with accept all cookies button
        acceptAllButton.onclick = () => {
            // hide cookie notice
            cookieNoticeElement.classList.remove(cookieNoticeVisibleClass);
            // store cookie accepting Google Analytics
            document.cookie = `${cookieName}=accepted; domain=.${domain}; ${cookieArguments}`;
            // load Google Analytics
            LoadAnalytics();
        };
        // when user interacts with save & dismiss button
        saveDismissButton.onclick = () => {
            // check state of analytics checkbox
            if (analyticsCheckbox.checked) {
                // hide cookie notice
                cookieNoticeElement.classList.remove(cookieNoticeVisibleClass);
                // store cookie accepting Google Analytics
                document.cookie = `${cookieName}=accepted; domain=.${domain}; ${cookieArguments}`;
                // load Google Analytics
                LoadAnalytics();
            } else {
                // hide cookie notice
                cookieNoticeElement.classList.remove(cookieNoticeVisibleClass);
                // store cookie denying Google Analytics
                document.cookie = `${cookieName}=denied; domain=.${domain}; ${cookieArguments}`;
            }
        };
    }
}
